/**
 * MTPRO Services – technical content for detail pages
 */
export const SERVICES_DATA = {
  feasibility: {
    title: 'Feasibility study & Bidding process management',
    details: [
      'Building/supporting feasibility stages',
      'Primary scheduling',
      'Bid terms',
      'Tender review',
      "Bidders' inquiries",
      'Consultant awarding',
    ],
  },
  contracts: {
    title: 'Contracts and Claims Management',
    details: [
      'Prepare Contracting/Subcontracting docs',
      'Review existing contracts',
      'Liability Identification',
      'Calculating damages',
      'Resolving claims/Arbitration',
    ],
  },
  management: {
    title: 'Program/Project Management',
    details: [
      'Develop schedules/manpower/cash flows',
      'Design review',
      'Change/Issue/Risk/Quality/Communication management',
      'Performance reports',
    ],
  },
  capabilities: {
    title: 'Developing Project Management Capabilities',
    details: [
      'Training services',
      'Human skills and leadership',
      'Outsourcing/Remote services',
      'Establish/Enhance corporate PMO',
    ],
  },
};
